<template>
  <div style="display: inline-block; width: 10px;">
    <v-icon small @click="up()">mdi-menu-up</v-icon>
    <v-icon small @click="down()">mdi-menu-down</v-icon>
  </div>
</template>

<script>
export default {
  name: 'up-down-elem',

  props: {
    id: [Object, String],
    upFunc: String,
    downFunc: String
  },

  methods: {
    up() {
      this.$store.commit(this.upFunc, this.id);
    },
    down() {
      this.$store.commit(this.downFunc, this.id);
    }
  }
}
</script>